import React from 'react';
import { ArrowUpRight, ArrowDownRight, Minus } from 'lucide-react';
import { ScorecardMetric } from '../data/mockData';
interface PersonalScorecardProps {
  scorecard: ScorecardMetric[];
}
export function PersonalScorecard({
  scorecard
}: PersonalScorecardProps) {
  return <section className="bg-slate-800/60 border border-slate-700/50 rounded-xl p-6 h-full flex flex-col" data-id="element-146">
      <h2 className="text-lg font-semibold text-white mb-4 flex items-center gap-2" data-id="element-147">
        <span className="w-1.5 h-5 bg-indigo-500 rounded-full" data-id="element-148"></span>
        Personal Scorecard
      </h2>

      <div className="overflow-x-auto" data-id="element-149">
        <table className="w-full text-left border-collapse" data-id="element-150">
          <thead data-id="element-151">
            <tr className="border-b border-slate-700/50 text-xs uppercase tracking-wider text-slate-400" data-id="element-152">
              <th className="pb-3 font-medium" data-id="element-153">Metric</th>
              <th className="pb-3 font-medium text-right" data-id="element-154">Actual</th>
              <th className="pb-3 font-medium text-right" data-id="element-155">Target</th>
              <th className="pb-3 font-medium text-center" data-id="element-156">Status</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-700/30" data-id="element-157">
            {scorecard.map(item => <tr key={item.name} className="hover:bg-slate-700/20 transition-colors" data-id="element-158">
                <td className="py-3 text-sm font-medium text-slate-200" data-id="element-159">
                  {item.name}
                </td>
                <td className="py-3 text-sm font-bold text-white text-right" data-id="element-160">
                  {item.actual}%
                </td>
                <td className="py-3 text-sm text-slate-400 text-right" data-id="element-161">
                  {item.target}%
                </td>
                <td className="py-3 text-center" data-id="element-162">
                  <div className="flex justify-center" data-id="element-163">
                    {item.status === 'above' && <span className="flex items-center gap-1 text-xs font-medium text-emerald-400 bg-emerald-400/10 px-2 py-1 rounded-md" data-id="element-164">
                        <ArrowUpRight className="w-3 h-3" data-id="element-165" /> Above
                      </span>}
                    {item.status === 'below' && <span className="flex items-center gap-1 text-xs font-medium text-red-400 bg-red-400/10 px-2 py-1 rounded-md" data-id="element-166">
                        <ArrowDownRight className="w-3 h-3" data-id="element-167" /> Below
                      </span>}
                    {item.status === 'meet' && <span className="flex items-center gap-1 text-xs font-medium text-slate-400 bg-slate-400/10 px-2 py-1 rounded-md" data-id="element-168">
                        <Minus className="w-3 h-3" data-id="element-169" /> Met
                      </span>}
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </section>;
}